import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trending-categories',
  templateUrl: './trending-categories.component.html',
  styleUrls: ['./trending-categories.component.scss']
})
export class TrendingCategoriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
